import { render, staticRenderFns } from "./ProductInformationComponent.vue?vue&type=template&id=21f02bdc&scoped=true&"
import script from "./ProductInformationComponent.vue?vue&type=script&lang=js&"
export * from "./ProductInformationComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProductInformationComponent.vue?vue&type=style&index=0&id=21f02bdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f02bdc",
  null
  
)

export default component.exports